// removed by extract-text-webpack-plugin
module.exports = {"pitch":"#282c31","this":"RecentMessages__this___3OVeG","sidebar":"RecentMessages__sidebar___1UHI-","wrap":"RecentMessages__wrap___1mQgA","content":"RecentMessages__content___2k9OL"};


//////////////////
// WEBPACK FOOTER
// ./src/groups/components/styles/RecentMessages.css
// module id = 2201
// module chunks = 0 1